import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchBanner: null,
  fetchBannerStart: null,
  fetchBannerSuccess: ['bannerData'],
  fetchBannerFailure: null,

  fetchRecentNews: ['pageNumber'],
  fetchRecentNewsStart: null,
  fetchRecentNewsSuccess: ['recentNews'],
  fetchRecentNewsFailure: null,

  fetchTrendingTags: null,
  fetchTrendingTagsStart: null,
  fetchTrendingTagsSuccess: ['trendingTags'],
  fetchTrendingTagsFailure: null,

  fetchTopNews: null,
  fetchTopNewsStart: null,
  fetchTopNewsSuccess: ['topNews'],
  fetchTopNewsFailure: null,

  increasePostCount: ['postId']
  // increasePostCountStart: null,
  // increasePostCountSuccess: ['topNews'],
  // increasePostCountFailure: null,
});

export { Types, Creators };
